import type { ReactNode } from 'react';

export function GuideSteps({ children }: { children: ReactNode }) {
  return <ol className="space-y-3">{children}</ol>;
}

interface StepProps {
  number: number;
  title: string;
  children: ReactNode;
}

export function GuideStep({ number, title, children }: StepProps) {
  return (
    <li className="glass-card relative overflow-hidden p-5">
      <div className="pointer-events-none absolute left-0 top-0 h-full w-[3px] bg-gradient-to-b from-neurax-electric via-neurax-plasma to-neurax-electric/0" />
      <div className="flex items-start gap-4">
        <div className="grid h-8 w-8 shrink-0 place-items-center rounded-full border border-neurax-electric/40 bg-neurax-electric/10 text-sm font-semibold text-neurax-electric">
          {number}
        </div>
        <div className="flex-1">
          <h3 className="font-display text-base font-semibold text-white">{title}</h3>
          <div className="mt-2 space-y-2 text-sm text-muted-foreground [&_a]:text-neurax-electric [&_a]:underline [&_a]:underline-offset-2 [&_code]:rounded [&_code]:bg-white/5 [&_code]:px-1.5 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-xs [&_code]:text-white [&_strong]:font-semibold [&_strong]:text-white">
            {children}
          </div>
        </div>
      </div>
    </li>
  );
}
